import React from 'react'
import Image, { ImageProps } from 'next/image'
import inSnapshotEnvironment from 'marketing-site/src/library/utils/inSnapshotEnvironment'

const CDN_DOMAIN = 'images.ctfassets.net'

function getSrcUrl(propsSrc: string) {
  if (propsSrc.startsWith(`//${CDN_DOMAIN}`)) {
    return `https:${propsSrc}`
  }

  return propsSrc
}

function getPropsOverrides() {
  const overrides: Partial<ImageProps> = {}

  if (inSnapshotEnvironment()) {
    overrides.priority = true
    overrides.unoptimized = true
  }

  return overrides
}

export default function NextImageWrapper(props: ImageProps): React.ReactElement {
  const propsOverrides: Partial<ImageProps> = getPropsOverrides()
  if (typeof props.src === 'string')
    return <Image {...props} {...propsOverrides} src={getSrcUrl(props.src)} />

  // static import image
  return <Image {...props} {...propsOverrides} />
}
